import type { ITrackingProgressTracker } from '@/modules/pmt/interfaces';
import { ProgressTracker } from './components/ProgressTracker';
import { buildStageList } from './progressTracker.utils';

export const TrackingProgressTracker: React.FC<ITrackingProgressTracker> = ({ hasIssue, milestone }) => {
  const progressTrackerState = {
    hasIssue,
    milestone, // current state
    stageList: buildStageList(milestone),
  };

  return <ProgressTracker {...progressTrackerState} />;
};
